<template>
  <div class="admin-users">
    <div class="panelheader border-2">

      <div class="title"> {{pageName}} </div>

      <div class="btn-wrapper">
        <el-button type="add" @click="onNewUser">New User</el-button>  
      </div>

    </div>

    <div class="users">
      <div v-if="newUser">
        <newuser @close="onClose"></newuser>
      </div>
      <div v-else-if="editUser">
        <edituser :userData="userData" @close="onClose"></edituser>
      </div>
      <div v-else>
        <usertable v-if='!reloading'
          @editUser="onEditUser" 
          @deleteUser="onDeleteUser">
        </usertable>
      </div>
    </div>  

    <!-- DELETE CONFIRM -->
    <el-dialog
      :visible.sync="showDeleteConfirm"
      width="50%">
      <h3 slot="title" style="text-align: left;">
        Delete User<span v-if="userToDelete.username"> '{{userToDelete.username}}'</span>?
      </h3>
      <div>Are you sure you wish to delete <span v-if="userToDelete.username"><strong>'{{userToDelete.username}}'</strong></span><span v-else>this user?</span></div>
      <div>This is <strong>permanent</strong> and can't be undone</div>

      <span slot="footer">
        <el-button @click="showDeleteConfirm = false">Cancel</el-button>
        <el-button type="danger" @click="doDelete">Delete</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import auth from '../../../auth';
import requests from '../../../requests';
import newUser from './NewUser.vue';
import editUser from './EditUser.vue';
import userTable from './UserTable.vue';

export default {
  name: 'admin-users',
  data () {
    return {
      pageName: 'Adminstration Users',
      users: [],
      newUser: false,
      editUser: false,
      userIsSuperAdmin: false,
      userData: {},
      reloading: false,
      showDeleteConfirm: false,
      userToDelete: {},
    }
  },
  beforeMount(){
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = (profile.role === 3);
  },
  updated() {
    this.reloading = false;
  },
  methods: {
    onNewUser() {
      this.editUser = false;
      this.newUser = true;
    },
    onEditUser(userData) {
      this.userData = userData;

      this.newUser = false;
      this.editUser = true;
    },
    onDeleteUser(user) {
      this.showDeleteConfirm = true;
      this.userToDelete = user;
    },
    doDelete() {
      var id = this.userToDelete;
      var context = this;
      requests.deleteUser(this, id, function(result) {
        console.log(result);
        if(result.action !== 'success') {
          console.log(result);
          context.$message({
            type: 'error',
            message: 'Couldn\'t delete user: ' + result.msg.body.msg,
          })
        }
        context.reloading = true;
        context.showDeleteConfirm = false;
      });
    },
    onClose() {
      this.newUser = false;
      this.editUser = false;
    },
  },
  components: {
    'newuser': newUser,
    'edituser': editUser,
    'usertable': userTable
  }
}
  // methods: {
    
  //   updateUser(data){
  //     this.newUserDisplay = false;
  //     this.editUserDisplay = true;
  //     this.userData = data.row;
  //     this.userData.role = String(data.row.role);
  //     this.userData.client_id = String(data.row.client_id);
  //   },

  //   deleteUser(id){
  //     var context = this;
  //     requests.deleteUser(this, id, function(result){
  //       if(result.action === 'success'){
  //         context.$message({
  //           type: 'success',
  //           message: 'Successfully deleted user'
  //         });
  //         context.users = [];
  //         context.getUsers();
  //       } else {
  //         context.$message({
  //           type: 'error',
  //           message: 'Failed to delete user'
  //         });
  //       }
  //     });
  //   },

  //   showNewUser(){
  //     this.newUserDisplay = true;
  //     this.editUserDisplay = false;
  //   },
  //   close(){
  //     this.userData = {
  //       name: '',
  //       username: '',
  //       email: '',
  //       client_id: '',
  //       role: ''
  //     };
  //     this.newUserDisplay = false;
  //     this.editUserDisplay = false;
  //   },
  //   onChangedUsers() {
  //     this.getUsers();
  //     this.close();
  //     this.$forceUpdate();
  //   },
  //   humanise(row, column) {
  //     var roles = ["General", "Booking", "Admin", "Super Admin"];
  //     return roles[parseInt(row.role)];
  //   },
  // },
  // components:{
  //   'new-user':newUser,
  //   'edit-user':editUser,
  // }
</script>

<style>

  .users {
    display: block;
    padding: 15pt;
    background-color: white;
  }

  .btn-wrapper {
    margin-top: 4pt;
    float: right;
    width: 20%;
    text-align: right;
    margin-right: 10pt;
  }

  .users .el-switch {
    float: left;
  }

  .users .el-select {
    float: left;
  }

  .el-table .email > .cell {
    word-break: break-all !important;
  }

</style>



// WEBPACK FOOTER //
// Users.vue?225ca27d